import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';


function ProjectAndTaskManagement() {
  return (
    <>
<Features docname="Project and Task Management"/>
<Advantages docname="Project and Task Management"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default ProjectAndTaskManagement;
